import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthContext';
import { useAuth } from './components/auth/AuthContext';
import LandingPage from './components/layout/LandingPage';
import Dashboard from './components/layout/Dashboard';
import WidgetPage from './components/WidgetPage';

const PrivateRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  return user ? element : <Navigate to="/" replace />;
};

function App() {
  // Check if we're on the widget route
  const isWidget = window.location.pathname === '/widget';

  // If it's the widget route, render only the WidgetPage without the router
  if (isWidget) {
    return <WidgetPage />;
  }

  // Otherwise render the full app with routing
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
          <Route path="/widget" element={<WidgetPage />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;